const MEDIA_ITEMS = [
  {
    title: '暑期档动作大片预告合集',
    type: '预告片',
    desc: '今年暑期档最值得期待的动作电影预告全收录，热血沸腾的精彩片段一睹为快。',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20trailer%20screenshot%20collage%20with%20dramatic%20explosions%20and%20intense%20fight%20scenes%2C%20warm%20golden%20and%20fiery%20orange%20cinematic%20lighting%2C%20movie%20trailer%20aesthetic%2C%20high%20contrast%20composition&width=700&height=400&seq=media-01&orientation=landscape',
    duration: '03:25',
  },
  {
    title: '高分悬疑电影精彩片段',
    type: '精彩片段',
    desc: '精选多部高分悬疑电影中最震撼的反转片段，每一个镜头都让人屏住呼吸。',
    img: 'https://readdy.ai/api/search-image?query=Suspense%20movie%20highlight%20scene%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere%2C%20noir%20cinematography%20style%2C%20warm%20amber%20light%20in%20darkness%2C%20cinematic%20composition%20with%20film%20grain&width=700&height=400&seq=media-02&orientation=landscape',
    duration: '05:12',
  },
  {
    title: '经典港片修复版对比特辑',
    type: '特辑',
    desc: '89部经典港片高清修复前后对比，重温黄金年代的画面质感与光影魅力。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20cinema%20restoration%20comparison%20scene%2C%20split%20screen%20showing%20old%20film%20grain%20versus%20restored%20high%20definition%2C%20nostalgic%20warm%20tones%2C%20cinematic%20split%20composition&width=700&height=400&seq=media-03&orientation=landscape',
    duration: '08:47',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-500 mt-2">热门电影预告片与精彩片段</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`97影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-50/30 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5" />
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-100/90 rounded text-[10px] font-mono text-foreground-600">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-1.5 py-0.5 text-[10px] font-medium bg-secondary-500/15 text-secondary-500 rounded">
                    {item.type}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}